export default __webpack_public_path__ + "static/media/primep.595e64fa.png";